<template>
  <div class="multi-column critical-component-clear">
    <content-carousel
      :cards="blocks"
      :title="content.title"
      :subtitle="content.subtitle"
      :cta-text="content.ctaText"
      :cta-url="content.ctaUrl"
      :card-type="content.cardType"
      :carousel-pagination="content.carouselPagination"
    />
  </div>
</template>

<script>

/**
 * Vue: Multi column (multi-column)
 * -----------------------------------------------------------------------------
 * A section to display article cards.
 * - Component settings: section / dynamic / async / scroll
 *
 * @param {Object} content - Section's text content.
 * @param {String} [content.title]- Title text.
 * @param {String} [content.subtitle]- Subtitle text.
 * @param {String} [content.ctaText]- CTA text.
 * @param {String} [content.ctaUrl]- CTA url.
 * @param {Boolean} [content.carouselPagination]- Carousel pagination.
 * @param {Array} blocks - Array of blocks
 */
import ContentCarousel from '~async/content-carousel/content-carousel.vue'

export default {
  name: 'MultiColumn',

  components: { ContentCarousel },

  props: {
    content: {
      type: Object,
      default: () => ({
        title: '',
        subtitle: '',
        ctaText: '',
        ctaUrl: '',
        cardType: '',
        carouselPagination: false,
      }),
    },
    blocks: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss">
@import './multi-column';
</style>
